module.exports = __webpack_public_path__ + "first-50_front.jpg?e96710cd561c7b0607421729e5e7b019";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50_front.jpg
// module id = 567
// module chunks = 0